import React from "react";
import {
  Card,
  IconButton,
  Typography,
  Box,
  Button,
  Tooltip,
} from "@mui/material";
import LinkIcon from "@mui/icons-material/Link";
import { useTranslation } from "react-i18next";

const MAX_LINK_LENGTH = 300;

const LinkCard = ({
  link,
  onDelete,
  onPaste,
  mode,
}: {
  link: string;
  onDelete: () => void;
  onPaste: () => void;
  mode: string;
}) => {
  const { t } = useTranslation();
  const truncatedLink =
    link.length > MAX_LINK_LENGTH
      ? `${link.substring(0, MAX_LINK_LENGTH)}...`
      : link;

  return (
    <>
      <Typography variant="h6" gutterBottom>
        {t("ลิงก์")}
      </Typography>
      <Card
        variant="outlined"
        sx={{
          display: "flex",
          alignItems: "center",
          p: 2,
          borderRadius: "12px", // Smooth border radius
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", flexGrow: 1 }}>
          <IconButton sx={{ mr: 2 }}>
            <LinkIcon fontSize="large" />
          </IconButton>
          <Box>
            <Typography fontWeight="bold">{t("กรุณาแนบลิงก์")}</Typography>
            <Tooltip title={link}>
              <Typography
                color="primary"
                sx={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  maxWidth: "250px", // Limit width before truncating
                  display: "block",
                }}
              >
                {truncatedLink}
              </Typography>
            </Tooltip>
          </Box>
        </Box>
        {link ? (
          <Button
            disabled={mode === "VIEW"}
            variant="outlined"
            color="error"
            onClick={onDelete}
          >
            {t("ลบลิงก์")}
          </Button>
        ) : (
          <Button
            disabled={mode === "VIEW"}
            variant="outlined"
            color="success"
            onClick={onPaste}
          >
            {t("วางลิงก์")}
          </Button>
        )}
      </Card>
    </>
  );
};

export default LinkCard;
